import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { errorToast } from "@/shared/utils/helpers";
import { AppsmenError } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const usePosOrderPut = () => {
  const branch = useBranchId();
  const { t } = useTranslation();

  const mutation = useMutation<any, AppsmenError, any>({
    mutationFn: ({ orderId, ...data }: any) => {
      return put2(
        `internal/secure/pos/v1/orders/information/${orderId}/${branch}`,
        data
      );
    },
    onSuccess: () => {
      toast.success(t("posOrders.orderPlaced"));
    },
    onError(error) {
      const showError =
        error.response.data.error_id === "paynl.onlinePaymentConnectionFailed";
      showError && errorToast(error.response.data.error_message);
    },
  });

  return mutation;
};

export default usePosOrderPut;
